import axios from 'axios'
import { projectAuth } from '../../Auth/firebase_config'
import { baseUrl } from '../config'

const addHealthJourney =(patientId, params) =>{
    return new Promise(async (resolve, reject) => {
        projectAuth.currentUser
        .getIdToken(true)
            .then(function (idToken) { 
                const reqBody = { headers: { Authorization: `${idToken}` } }

                axios.post(
                    `${baseUrl}/patient/${patientId}/healthJourney/addEntry`, 
                    params,
                    reqBody
                )
                .then((res) => resolve(res.data))
                .catch((err) => reject(JSON.stringify(err)))

                
            })
            .catch((error) => reject(error))

    })
}

export default addHealthJourney